import {RelativeLink} from 'lib/ui/link/RelativeLink'
import styled from 'styled-components'
import {useEventRoutes} from 'organization/Event/EventRoutes'
import React from 'react'
import grey from '@material-ui/core/colors/grey'
import {areaRoutes} from 'organization/Event/Area/AreaRoutes'
import {useArea} from 'organization/Event/Area/AreaProvider'

export default function Card() {
  const {area, totalAttendees} = useArea()
  const label = `view ${area.name} area`
  const eventRoutes = useEventRoutes()
  const routes = areaRoutes({area, eventRoutes})

  return (
    <RelativeLink to={routes.root} disableStyles aria-label={label}>
      <Box>
        <span>{area.name}</span>
        <span>{totalAttendees}</span>
      </Box>
    </RelativeLink>
  )
}

const Box = styled.div`
  border: 1px solid ${(props) => props.theme.colors.border};
  padding: ${(props) => props.theme.spacing[5]};
  margin-bottom: ${(props) => props.theme.spacing[4]};
  border-radius: 6px;
  display: flex;
  justify-content: space-between;

  &:hover {
    background: ${grey[200]};
  }
`
